import Controller from '@ember/controller';

export default class AuthenticatedIssuesController extends Controller {}
